define.alias("shared/components/shared-ig-media-card", "settings/components/shared-ig-media-card");